"use client";

import React from "react";

import { NotificationBadge } from "./NotificationBadge";
import { StatusBadge } from "./StatusBadge";
import { BadgeVariant, BadgeProps } from "./types";

/**
 * @deprecated use `Badge` from `@faire/slate/components/badge` for numbers or `Tag` from `@faire/slate/components/tag` for text - since 2025-04-05
 *
 * @trackcomponent
 */
export const Badge: React.FC<BadgeProps> = (props) => {
  const { variant } = props;

  if (variant === BadgeVariant.Notification) {
    return <NotificationBadge {...props} />;
  } else {
    return <StatusBadge {...props} />;
  }
};
